<div class="status">
    <span class="{{ styles[state]?.class }}">
      {{('productCartStatus.' + state) | translate }}
    </span>
</div>